import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import Menu from "../controllers/menu_controller";
import Gallery from "../controllers/gallery_controller";
import GalleryTrigger from "../controllers/gallery_trigger_controller";
import Analytics from "../controllers/analytics_controller";
import Technology from "../controllers/technology_controller";
const app = Application.start();
app.register("menu", Menu);
app.register("gallery", Gallery);
app.register("gallery-trigger", GalleryTrigger);
app.register("analytics", Analytics);
app.register("technology", Technology);
